export class AllocationRequestAccumulationPeriodMembership {
	public hasTaskVariant;
	public hasTaskType;
	
	constructor(obj) {
		this.hasTaskVariant = obj.hasTaskVariant;
		this.hasTaskType = obj.hasTaskType;
	}
} 
